import { render, staticRenderFns } from "./DepositAddr.vue?vue&type=template&id=49a352e8&"
import script from "./DepositAddr.vue?vue&type=script&lang=js&"
export * from "./DepositAddr.vue?vue&type=script&lang=js&"
import style0 from "./DepositAddr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports